module.exports={render:function (){with(this) {
  return _h('div', {
    staticClass: "menu-cart"
  }, [_h('div', {
    staticClass: "cart-totalnum"
  }, [_h('span', {
    staticClass: "num"
  }, [_s(totalNumber)])]), " ", _h('div', {
    staticClass: "cart-desc"
  }, [_h('span', {
    staticClass: "text"
  }, ["共" + _s(totalNumber) + "个菜"])]), " ", _h('div', {
    staticClass: "cart-price"
  }, [_h('span', {
    staticClass: "price"
  }, ["￥" + _s(totalPrice)])]), " ", _h('button', {
    staticClass: "cart-btn",
    on: {
      "click": gotoCart
    }
  }, ["查看购物车"])])
}},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-1ed29c40!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MenuCart.vue
 ** module id = 70
 ** module chunks = 1
 **/